export { AiChatMessage } from '../entities'
export type { AiChatMessage as default } from '../entities'
